<template>
  <div>
    <div class="mb-4">
      <p class="text-subtitle-2 font-weight-medium mb-1">
        {{ title }}
      </p>
      <!-- eslint-disable vue/no-v-html -->
      <p
        class="text-body-2 primary-grey--text mb-0"
        v-html="description"
      />
    </div>

    <GCarousel
      v-if="$isMobile"
      class="paywall-carousel"
    >
      <GCarouselItem
        v-for="bundle in bundles"
        :key="bundle.id"
      >
        <PlanCard
          class="paywall-plan-card"
          :title="bundle.title"
          :subtitle="`${bundle.questions} questions`"
          :price="bundle.price"
          :buttons="buttons"
          :card-border-color="COLORS.grainfoxAIButton"
          :card-clicked="selectedKey === bundle.id"
          @card-click="onBundleSelected(bundle)"
        />
      </GCarouselItem>
    </GCarousel>
    <div
      v-else
      class="d-flex flex-wrap"
    >
      <PlanCard
        v-for="bundle in bundles"
        :key="bundle.id"
        :title="bundle.title"
        :subtitle="`${bundle.questions} questions`"
        :price="bundle.price"
        :buttons="buttons"
        :card-border-color="COLORS.grainfoxAIButton"
        :card-clicked="selectedKey === bundle.id"
        class="mr-4"
        @card-click="onBundleSelected(bundle)"
      />
    </div>
  </div>
</template>

<script>
import PlanCard from './PlanCard.vue';
import { COLORS } from '@/helpers/colors';
import CATALOG from './data/_catalog';
import { mapGetters } from 'vuex';
import GCarousel from '../generic/GCarousel.vue';
import GCarouselItem from '../generic/GCarouselItem.vue';

export default {
  name: 'BundleSelection',

  components: {
    PlanCard,
    GCarousel,
    GCarouselItem,
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    description: {
      type: String,
      default: '',
    },

    buttons: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      selectedKey: 'Sinoa-Intro-Plan',
      COLORS,
    };
  },

  computed: {
    ...mapGetters('subscription', ['isCanadian']),

    bundles() {
      const region = this.isCanadian ? 'CA' : 'US';
      return (CATALOG[region] && CATALOG[region].sinoa) || [];
    },

    getBundleByKey() {
      return (key) => this.bundles.find((bundle) => bundle.id === key);
    },
  },

  methods: {
    getBundleWithCurrencyId(key) {
      const base = this.getBundleByKey(key);
      const currencySuffix = this.isCanadian ? 'CAD' : 'USD';
      if (!base) return null;
      return {
        ...base,
        originalId: base.id,
        id: `${base.id}-${currencySuffix}`,
      };
    },

    onBundleSelected(bundle) {
      const updatedBundle = this.getBundleWithCurrencyId(bundle.id);
      this.selectedKey = bundle.id;
      this.$emit('bundle-selected', updatedBundle);
    },
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .paywall-carousel {
    max-width: 100vw;
    overflow: hidden;
  }

  .paywall-plan-card ::v-deep .v-card,
  .paywall-plan-card ::v-deep .v-card[width],
  .paywall-plan-card ::v-deep .v-card[width="280px"] {
    width: 240px !important;
    min-width: 240px !important;
    max-width: 240px !important;
  }

  .paywall-carousel ::v-deep .g-carousel__items {
    max-width: calc(100vw - 48px);
  }
}
</style>
